export default __webpack_public_path__ + "6cbd85a475f43140e430e60a0a77b1d2.png";